import React from 'react';
import Modal from 'react-modal';
import moment from 'moment';
import { PagoRequest } from '../../../models/Pago';
import Loading from '../../Animations/loadScreen';
import Button from '../../Forms/Button';
import Checkbox from '../../Forms/Checkbox';
import Input from '../../Forms/Input';
import { formatCurrencyStyled } from '../../visuals/currency.formatted';
import { ArgumentBinded } from '../handlers/pago.state';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: '80vh',
        padding: '1em',
        border: 'none',
        background: 'transparent'
    }
};

interface PagosFindModalProps {
    isOpen: boolean;
    cfdi: PagoRequest;
    isLoading: boolean;
    findingExecuted: boolean;
    argBillBinding: ArgumentBinded[];
    binderIndexes: string[];
    eventid?: string;
    // Emitters
    onRequestClose: () => void;
    onSearch: () => void;
    onCheckSelected: (index: string) => () => void;
    onSelectAndClose: () => void;
    onRelateWithExternal: () => void;
}

function PagosFindModal({
    isOpen,
    cfdi,
    isLoading,
    findingExecuted,
    argBillBinding,
    binderIndexes,
    eventid,
    onRequestClose,
    onSearch,
    onCheckSelected,
    onSelectAndClose }: PagosFindModalProps) {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={customStyles}
            ariaHideApp={false}
            overlayClassName={'pagosOverlay'}
            contentLabel="Buscar Factura relacionada"
        >
            <div id="_BusquedaFacturas">
                <h4>Buscar Facturas relacionadas</h4>
                <div className="card table findBillRelated">
                    <div className="cardTitle withClose">
                        <div />
                        <i className="material-icons" onClick={onRequestClose}>
                            close
                        </i>
                    </div>
                    <div className="cardBody">
                        <div className="row three lg-two sm-gap-compressed">
                            <Input type='text' value={cfdi.receptor.nombre} label="Nombre" disabled={true} />
                            <Input type='text' value={cfdi.receptor.rfc} label="RFC" disabled={true} />
                            <div className="actions">
                                {
                                    isLoading ?
                                        <Loading display={true} relativePos={true} svgHeight={'45px'} svgWidth={'45px'} />
                                        : <div />
                                }
                                <Button primary={true} handleClick={onSearch} disabled={findingExecuted && !argBillBinding.length}>
                                    <span>Buscar</span>
                                </Button>
                            </div>
                        </div>
                        {
                            findingExecuted && !argBillBinding.length ?
                                <div className="_empty">
                                    <h3>No se encontraron facturas pendientes con este RFC</h3>
                                    {
                                        /*
                                        // NOTE: [February 27, 2026] PagosExternalBill is not completed, finish before giving this option back
                                        <Button secondary={true} handleClick={onRelateWithExternal}>
                                            <span>Relacionar con factura emitida fuera de FiscalPOP</span>
                                        </Button>
                                        */
                                    }
                                </div>
                                : ''
                        }
                        {
                            findingExecuted && argBillBinding.length ?
                                <div className="card table noShadow _relatedBillCard">
                                    <div className="cardTitle">
                                        <div className="billsHeader billOptions">
                                            <p className="date">Fecha de emisión</p>
                                            <p className="serie">Serie</p>
                                            <p className="folio">Folio</p>
                                            <p className="parcialidad">Parcialidad</p>
                                            <p className="monto">Monto total</p>
                                            <p className="pendiente">Pendiente</p>
                                        </div>
                                    </div>
                                    <div className="cardBody">
                                        <div className="billOptionWrap">
                                            {argBillBinding.map((binding, i) => {
                                                const offset = binding.argument.paymentEvents.some(p => p.paymentNum === 0);
                                                // WHen editing, expects isCLosed & wasCanceled
                                                const nextPayEvent = binding.argument.paymentEvents.filter(ev => !ev.isClosed || (!!ev.isClosed && !!ev.wasCanceled) || (ev._id === eventid))[0];
                                                return (
                                                    <div key={i} className="billOptions">
                                                        <Checkbox value={binderIndexes.includes(binding.argument._id)} onChange={onCheckSelected(binding.argument._id)} />
                                                        <p className="date">{moment(new Date(binding.cfdi.json["@"].Fecha).getTime()).format('DD/MMM/YYYY')}</p>
                                                        <p className="serie">{binding.cfdi.json["@"].Serie}</p>
                                                        <p className="folio">{binding.cfdi.json["@"].Folio}</p>
                                                        <p className="parcialidad">{nextPayEvent.paymentNum + (offset ? 1 : 0)} de {binding.argument.paymentEvents.length}</p>
                                                        <p className="monto">{formatCurrencyStyled(parseFloat(binding.cfdi.json['@'].Total))}</p>
                                                        <p className="pendiente">{formatCurrencyStyled(binding.insoluto)}</p>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <div className="selectedActions">
                                            <Button primary={true} handleClick={onSelectAndClose} disabled={!binderIndexes.length}>
                                                <span>Agregar seleccionados</span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default PagosFindModal;
